import { render, staticRenderFns } from "./Auditorium.vue?vue&type=template&id=24541103&scoped=true&"
import script from "./Auditorium.vue?vue&type=script&lang=js&"
export * from "./Auditorium.vue?vue&type=script&lang=js&"
import style0 from "./Auditorium.vue?vue&type=style&index=0&id=24541103&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24541103",
  null
  
)

export default component.exports